import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  InsertInventory,
  InsertInventoryRequest,
} from "../../domain/usecases/insert-inventory";
import { InvalidFieldError } from "../../validation/errors";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbInsertInventory implements InsertInventory {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async insert(request: InsertInventoryRequest): Promise<void> {
    const response = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: request,
    });

    switch (response.statusCode) {
      case HttpStatusCode.ok:
        return response.body;
      case HttpStatusCode.noContent:
        return;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      case HttpStatusCode.badRequest:
        throw new InvalidFieldError();
      default:
        throw new UnexpectedError();
    }
  }
}
